export default {
    loginData:null,
    linkCredential:null,
}